var profileStyles = function profileStyles(theme) {
    return {
        container: {
            background: '#F0F0F0 0% 0% no-repeat padding-box',
            width: '100%',
            fontFamily: "'Roboto', sans-Serif",
            display: 'flex',
            justifyContent: 'center',
            '@media screen and (max-width: 1300px)': {
                flexWrap: 'wrap'
            }
        },
        profileWrapper: {
            padding: '70px 10px 10px 50px',
            position: 'relative',
            '@media screen and (max-width: 1300px)': {
                padding: '70px 10px 10px 10px !important'
            }
        },
        profileContainer: {
            background: '#FFFFFF 0% 0% no-repeat padding-box',
            boxShadow: '0px 3px 6px #00000029',
            borderRadius: '9px',
            opacity: '1',
            maxWidth: '770px',
            display: 'flex',
            justifyContent: 'center',
            height: '100%',
            overflow: 'auto'
        },
        profileIconWrapper: {
            maxWidth: '100px',
            maxHeight: '100px',
            width: '100px',
            height: "100px",
            position: 'absolute',
            top: '1%',
            background: '#fff',
            borderRadius: '50%',
            boxShadow: '0px 3px 6px #00000029',
            border: '3px solid #FFFFFF'
        },
        profileIcon: {
            width: '100%',
            height: "100%",
            borderRadius: '50%'
        },
        contentWrapper: {
            padding: '40px 60px 10px 60px',
            textAlign: 'center',
            width: '100%'
        },
        summary: {
            color: '#727272',
            fontSize: '18px',
            maxWidth: '300px',
            marginTop: '3px',
            margin: 'auto'

        },
        link: {
            color: '#1B5ACC',
            fontSize: '16px',
            marginTop: '8px',
            display: 'block',
            textDecoration: 'none'
        },
        line: {
            border: '0.5px solid #EBEBEB',
            marginTop: '30px',
            marginBottom: '30px'
        },
        about: {
            maxWidth: '570px',
            fontSize: '15px',
            margin: '10px auto 0 auto',
            color: '#7C7C7C',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        },
        experience: {
            display: 'flex',
            justifyContent: 'space-evenly',
            '& > div': {
                padding: '0 5px'
            }
        },
        socialContainer: {
            paddingTop: '20px',
            paddingBottom: '30px',
            display: 'flex',
            justifyContent: 'space-evenly'
        },
        formContainer: {
            padding: '20px 50px 10px 10px',
            maxWidth: '700px',
            '& input': {
                padding: "12.5px 14px",
                border: '1px solid rgba(0, 0, 0, 0.5)',
                borderRadius: '3px',
                background: "none",
                fontSize: '14px'
            },
            '& textarea': {
                fontSize: '14px',
                border: '1px solid rgba(0, 0, 0, 0.5)',
                borderRadius: '3px',
                background: "none",
                padding: "12.5px 14px",
                width: '95.7% !important',
                height: '130px',
                maxHeight: '200px'
            },
            '& label': {
                color: 'rgba(0, 0, 0, 0.5)',
                fontSize: '14px'
            },
            '@media screen and (max-width: 1300px)': {
                padding: '20px 10px 10px 10px !important'
            }
        },
        formItem: {
            display: 'flex',
            flexDirection: 'column',
            '& p': {
                color: 'red',
                margin: '0',
                fontSize: '12px'
            }
        }
    };
};

export default profileStyles;


// WEBPACK FOOTER //
// ./node_modules/@int/profile_v1/lib/jss/ProfileStyles.js